import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import ProfileDrawer from "./ProfileDrawer";

function Navbar() {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dark, setDark] = useState(
    document.documentElement.getAttribute("data-theme") === "dark"
  );

  const toggleDark = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.setAttribute("data-theme", next ? "dark" : "light");
    localStorage.setItem("theme", next ? "dark" : "light");
  };

  return (
    <>
      <div className="navbar">
        <div className="navbar-left" onClick={() => navigate("/dashboard")}>
          <img src="/favicon.png" alt="Career Engine Logo" className="navbar-logo" />
        </div>

        <nav className="navbar-links">
          <NavLink to="/dashboard" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Dashboard</NavLink>
          <span className="nav-divider" />
          <NavLink to="/documents" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Document Library</NavLink>
        </nav>

        <div className="navbar-right">
          <button className="navbar-theme-toggle" onClick={toggleDark} title={dark ? "Switch to light mode" : "Switch to dark mode"}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill={dark ? "#f59e0b" : "none"} stroke={dark ? "#f59e0b" : "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          </button>
          <button className="navbar-profile-icon" onClick={() => setDrawerOpen(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
          </button>
        </div>
      </div>

      {drawerOpen && <ProfileDrawer onClose={() => setDrawerOpen(false)} />}
    </>
  );
}

export default Navbar;
